<template>
  <div class="mh-page detail">
    <AppShimmer v-if="loading" type="detail" />
    <template v-else>
      <div class="hero">
        <img :src="imageUrl" loading="lazy" @error="imageError" /><button
          class="back"
          @click="$router.back()"
        >
          <i class="bi bi-chevron-left"></i>
        </button>
        <div class="hero-actions">
          <button @click="toggleSave">
            <i
              :class="saved ? 'bi bi-bookmark-fill' : 'bi bi-bookmark'"
            ></i></button
          ><button @click="share"><i class="bi bi-share"></i></button>
        </div>
      </div>
      <main class="mh-content">
        <span class="category">{{ type.toUpperCase() }}</span>
        <h1>{{ title }}</h1>
        <p class="sub">{{ company }} · {{ location }}</p>
        <div class="fresh">{{ dateTime }} · {{ age }}</div>
        <div v-if="price" class="price">{{ price }}</div>
        <div class="quick">
          <a v-if="phone" :href="'tel:' + phone"
            ><i class="bi bi-telephone"></i> Call</a
          ><a
            v-if="whatsapp"
            :href="'https://wa.me/' + cleanWhatsapp"
            target="_blank"
            ><i class="bi bi-whatsapp"></i> WhatsApp</a
          ><button v-if="hasLocation" @click="map">
            <i class="bi bi-geo-alt"></i> Direction</button
          ><a v-if="item.website" :href="item.website" target="_blank"
            ><i class="bi bi-globe"></i> Website</a
          ><a v-if="item.external_url" :href="item.external_url" target="_blank"
            ><i class="bi bi-box-arrow-up-right"></i> Visit</a
          ><button @click="share"><i class="bi bi-share"></i> Share</button>
        </div>
        <section class="mh-card block">
          <h2>Description</h2>
          <p>{{ item.description || "Details will be updated soon." }}</p>
        </section>
        <section class="mh-card block">
          <h2>Details</h2>
          <div class="details">
            <p v-for="row in detailRows" :key="row[0]">
              <span>{{ row[0] }}</span
              ><strong>{{ row[1] }}</strong>
            </p>
          </div>
        </section>
        <button
          class="report"
          @click="$alert('Thanks. We will review this listing.', 'info')"
        >
          <i class="bi bi-flag"></i> Report listing
        </button>
      </main> </template
    ><BottomNavigation />
  </div>
</template>
<script>
import api from "@/api";
import { formatAge, formatDateTime } from "@/utils/format";
import { addRecentlyViewed } from "@/utils/storage";
import BottomNavigation from "@/components/BottomNavigation.vue";
import AppShimmer from "@/components/AppShimmer.vue";
export default {
  name: "DetailView",
  components: { BottomNavigation, AppShimmer },
  data() {
    return { loading: true, item: {}, imgPath: "", saved: false };
  },
  computed: {
    type() {
      return this.$route.query.name || "listing";
    },
    title() {
      return this.item.name || this.item.title || "Listing Details";
    },
    company() {
      return this.item.companyname || this.item.jobtype || this.type;
    },
    location() {
      return this.item.location || this.item.joblocation || "Solapur";
    },
    phone() {
      return this.item.mobile || this.item.contact || "";
    },
    whatsapp() {
      return this.item.whatsapp || this.phone;
    },
    cleanWhatsapp() {
      const p = String(this.whatsapp).replace(/\D/g, "");
      return p.length === 10 ? `91${p}` : p;
    },
    hasLocation() {
      return !!(this.item.latitude && this.item.longitude) || !!this.location;
    },
    dateValue() {
      return this.item.created_at || this.item.iddate || this.item.fromdate;
    },
    dateTime() {
      return formatDateTime(this.dateValue);
    },
    age() {
      return formatAge(this.dateValue);
    },
    price() {
      const v = this.item.cost || this.item.price || this.item.offer;
      return v ? (String(v).includes("₹") ? v : "₹" + v) : "";
    },
    imageUrl() {
      const i = this.item.img;
      if (!i) return this.placeholder;
      if (/^http/.test(i)) return i;
      return `${this.$asset_path}${this.imgPath || this.type}/${i}`;
    },
    placeholder() {
      return `https://placehold.co/800x500/f1f5f9/667085?text=${this.type.toUpperCase()}`;
    },
    detailRows() {
      return [
        ["Category", this.type],
        ["Location", this.location],
        ["Date", this.dateTime],
        ["Time", this.item.time],
        ["Experience", this.item.jobexperience],
        ["Education", this.item.educationreq],
        ["Area", this.item.feet],
      ].filter((r) => r[1]);
    },
  },
  async mounted() {
    try {
      const r = await api.getListingDetails(this.$route.query.id, this.type);
      this.item = r.data?.datarow || {};
      this.imgPath = r.data?.img_path || this.type;
      addRecentlyViewed({ ...this.item, type: this.type });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    imageError(e) {
      e.target.src = this.placeholder;
    },
    async toggleSave() {
      if (!localStorage.getItem("token"))
        return this.$router.push({
          path: "/login",
          query: { next: this.$route.fullPath },
        });
      try {
        const r = await api.toggleSaved(this.item.id, this.type);
        this.saved = Boolean(r.data?.saved);
        this.$alert(
          this.saved ? "Listing saved" : "Removed from saved",
          this.saved ? "success" : "info",
        );
      } catch (e) {
        this.$alert(
          e.response?.data?.message || "Could not update saved listing",
          "error",
        );
      }
    },
    async share() {
      const shareType = this.item.offer ? "offer" : this.type;
      const slug = this.item.slug || "listing";
      const shareUrl = new URL(
        `/app/${encodeURIComponent(shareType)}/${encodeURIComponent(slug)}`,
        window.location.origin,
      );

      shareUrl.searchParams.set("lid", this.item.id);
      // window.alert(`Sharing link:\n${shareUrl.toString()}`);

      if (navigator.share) {
        try {
          await navigator.share({
            title: this.title,
            text: "\n",
            url: shareUrl.toString(),
          });
        } catch (error) {
          // Closing the native share dialog is not an application error.
          if (error.name !== "AbortError") {
            this.$alert("Could not share this listing", "error");
          }
        }
        return;
      }

      if (!navigator.clipboard) {
        this.$alert("Sharing is not supported by this browser", "warning");
        return;
      }

      try {
        await navigator.clipboard.writeText(shareUrl.toString());
       
      } catch (error) {
        this.$alert("Could not copy share link", "error");
      }
    },
    map() {
      const q =
        this.item.latitude && this.item.longitude
          ? `${this.item.latitude},${this.item.longitude}`
          : this.location;
      window.open(`https://maps.google.com/?q=${encodeURIComponent(q)}`);
    },
  },
};
</script>
<style scoped>
.hero {
  height: 310px;
  position: relative;
  background: #ede9fe;
}
.hero:after {
  content: "";
  position: absolute;
  inset: 45% 0 0;
  background: linear-gradient(transparent, rgba(15, 5, 45, 0.65));
}
.hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.back,
.hero-actions button {
  position: relative;
  z-index: 2;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  background: #fffffff0;
  color: #30106f;
  font-size: 19px;
  box-shadow: 0 7px 20px #0003;
}
.back {
  position: absolute;
  left: 14px;
  top: 14px;
}
.hero-actions {
  position: absolute;
  z-index: 3;
  right: 14px;
  top: 14px;
  display: flex;
  gap: 8px;
}
.mh-content {
  position: relative;
  margin-top: -25px;
  border-radius: 25px 25px 0 0;
  background: #f8fafc;
  z-index: 4;
}
.category {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 7px;
  background: #5821ff;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
}
.detail h1 {
  font-size: 23px;
  margin: 10px 0 4px;
  line-height: 1.3;
}
.sub,
.fresh {
  color: #64748b;
}
.fresh {
  font-size: 10px;
  margin-top: 6px;
}
.price {
  font-size: 20px;
  font-weight: 700;
  margin: 10px 0;
  color: #5821ff;
}
.quick {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 14px 0;
}
.quick a,
.quick button {
  min-height: 52px;
  display: grid;
  place-items: center;
  border: 1px solid #e6e1f5;
  border-radius: 14px;
  background: #fff;
  color: #5821ff;
  text-decoration: none;
  font-size: 10px;
  font-weight: 600;
  box-shadow: 0 6px 15px rgba(38, 26, 79, 0.05);
}
.quick a i,
.quick button i {
  font-size: 17px;
}
.block {
  padding: 15px;
  margin: 10px 0;
}
.block h2 {
  font-size: 15px;
}
.block p {
  font-size: 12px;
  line-height: 1.65;
}
.details p {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f4;
  padding: 8px 0;
}
.details span {
  color: #64748b;
}
.report {
  width: 100%;
  border: 0;
  background: transparent;
  color: #ef4444;
  padding: 14px;
}
</style>
